// Üstteki sezon seçici (MainLayout). Seçim tüm ekranları süzer: Teklifler, Takvim, Raporlar, Gösterge Paneli.
import React, { useEffect } from 'react';
import { CalendarRange } from 'lucide-react';
import { useData } from '../context/DataContext';
import { useSeason } from '../context/SeasonContext';
import { ALL_SEASONS, viewSeasonOptions } from '../utils/season';

export default function SeasonSelect() {
  const { data, fetchData } = useData();
  const { activeSeason, selectedSeason, setSelectedSeason } = useSeason();
  // Sezon listesi tekliflerden çıkar; Raporlar/Odalar gibi teklif yüklemeyen sayfalarda da dolu olsun
  useEffect(() => { if (!data.offers) fetchData('offers'); }, [data.offers, fetchData]);
  const options = viewSeasonOptions(data.offers || [], activeSeason, selectedSeason);

  return (
    <label className="flex items-center gap-2 text-sm">
      <CalendarRange size={16} className="text-gray-500 dark:text-gray-400 shrink-0" />
      <span className="sr-only">Sezon</span>
      <select
        value={selectedSeason}
        onChange={e => setSelectedSeason(e.target.value)}
        title="Seçili sezon tüm ekranları süzer"
        className="p-1.5 pr-7 border rounded-lg bg-white dark:bg-gray-800 dark:border-gray-600 dark:text-white text-sm font-medium"
      >
        <option value={ALL_SEASONS}>Tüm Sezonlar</option>
        {options.map(s => (
          <option key={s} value={s}>{s} Sezonu{s === activeSeason ? ' (aktif)' : ''}</option>
        ))}
      </select>
    </label>
  );
}
